import FrequencyHelper from '@/components/buy-stack/FrequencyHelper';
import ComponentToggleSignal from '@/components/component-toggle-signal';
import Modal from '@/components/Modal';
import peopleIcon from '@/icons/people-icon.svg';

const frequencyHelperLabel = 'How Large is Your Household?';
const peopleIconAlt = 'People Icon';

/**
 * Renders a button group component for frequency helper.
 * Clicking on the button opens a modal with frequency helper content.
 */
export default function FrequencyHelperButtonGroup() {
  const modal = new ComponentToggleSignal();

  return (
    <>
      <div className="flex flex-col gap-y-1">
        <a
          className="self-center text-sm tracking-normal"
          onClick={() => modal.open()}
        >
          <img
            src={peopleIcon}
            alt={peopleIconAlt}
            className="mr-1 inline size-4.5 align-middle"
          />
          <span className="font-medium">{frequencyHelperLabel}</span>
        </a>
      </div>
      <Modal controller={modal}>
        <div className="grid h-3/4 items-center md:h-full">
          <FrequencyHelper />
        </div>
      </Modal>
    </>
  );
}
